import { CanActivateFn } from '@angular/router';
import { AuthService } from './auth.service';
import { inject } from '@angular/core';
import { NavController } from '@ionic/angular';
import { PlatformService } from '../platform/platform.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const navController = inject(NavController);
  const platformService = inject(PlatformService);
  const isCordova = platformService.isCordova();

  if (!authService.isAuthenticatedSignal()) {
    // User is not authenticated, redirect to login page
    const queryParams = { signOutParam: 'ACCESS_DENIED' };
    const path = isCordova ? '/sign-in' : '/network-check';
    navController.navigateRoot([path], { queryParams });
    return false;
  }

  return true;
};
